import requestHelper from "../../plugins/requestHelper";
// import { findClosestElementByClass } from "../helpers/dom/closest";
import errors from "../../plugins/errors";
import lozad from "lozad/dist/lozad.js";
import { paralax } from "../../plugins/paralax";
// import { elements } from "../helpers/dom/elementsManagement";
import { prepareAllPossibleSearchEngines } from "../searchChannels/searchChannels";
import { eDropdown } from "../dropdown/dropdown";
import { dropdownAnimation } from "../dropdown/dropdownAnimation";
import { dAction } from "../dataAction/dataAction";
import { toggleBox } from "../toggleBox/toggleBox";
import { approvals } from "../approvals/approvals";
import { formInputs } from "../forms/inputs";
import { sForm } from "../ajaxForm/ajax";
// import { bindTooltip } from "../../../vendors/tooltips";
// import alignItems from "../../plugins/alignItems";
// import scrollTo from "../../plugins/scrollTo";
Vue.component("offer-cards", {
	delimiters: ["{[{", "}]}"],
	props: ["dataofferurl", "activate"],
    template: "#offer-cards",
	data: function () {
		return {
			offer_cards: null,
			filters: null,
			bonus: null,
			packages: null,
			popups: null,
			query: [],
			activated: false,
			active: this.activate,
			dataElement: null,
			filesVisibility: false,
			filtersID: '',
			filtersObj: null,
			noOffer: null,
			redirect: null,
		};
	},
    watch: {
		active(newValue, oldValue) {
			// console.log('updated', this.activate);
			if (newValue === true && !this.activated) {
				this.urlRefresh();
				this.fetchData();
				this.activated = true;
			}
		},
	},
	created() {
		if (this.active === "true") {
			// this.urlRefresh();
			this.fetchData();
		}
	},
	updated() {
		eDropdown.init();
		dropdownAnimation.offerDropdown();
		dAction.init();
		toggleBox.toggle({
			targetClassName: "contactAcceptances",
			parentClassName: "contact-box__approvals",
			contentClassName: "contactApprovalsContent",
			state: "showHide",
		});
		approvals.acceptAll(
			"totalCheck",
			"contact-box__approvals",
			"contactApprovalsContent"
		);

		formInputs.init(document.querySelectorAll("input, textarea"));
		$("[type=tel]").mask("000000000");
		sForm.initSend();
		// const $appPacketsTv = this.dataElement;
		// if (this.dataElement) {
		// 	elements.counter($appPacketsTv, "tvPackagesInTable", 4);
		// }
		prepareAllPossibleSearchEngines();
		const observer = lozad(".lozad", {
			// load: function(el) {
			// console.log('loading element');

			// Custom implementation to load an element
			// e.g. el.src = el.getAttribute('data-src');
			// },
			loaded: function (el) {
				if (el.hasAttribute("data-object-fit") && el.tagName == "PICTURE") {
					objectFitPolyfill(el.querySelector("img"));
				}
			},
		});
		observer.observe();

		const imgLoadOnStart = document.querySelectorAll("[data-lozad-start]");
		var timeoutLozad;
		timeoutLozad = setTimeout(() => {
			if (document.body.classList.contains("testing")) {
				[].forEach.call(document.querySelectorAll(".lozad"), (img) =>
					observer.triggerLoad(img)
				);
			} else {
				[].forEach.call(imgLoadOnStart, (img) => observer.triggerLoad(img));
			}
		}, 1000);
		paralax.init();

		const offer_forms = Array.from(this.$el.querySelectorAll("[data-popup]"));
		offer_forms.forEach((offer_form) => {
			const recaptcha = offer_form.querySelector("#leadform_recaptcha");
			if (recaptcha) {
				window["leadform_recaptcha_" + recaptcha.getAttribute("data-form-id")] =
					grecaptcha.render(recaptcha, {
						sitekey: recaptcha.getAttribute("data-sitekey"),
						callback: function () {
							const recaptchaLeadformError = form.querySelector(
								"#leadform_recaptchaError"
							);
							if (recaptchaLeadformError.classList.contains("is-shown")) {
								recaptchaLeadformError.classList.remove("is-shown");
							}
						},
					});
			}
		});


		//cleaning URL from disabled filters
		this.urlRefresh();
	},
    mounted() {
    },
    methods: {
		activateTable: function (isVisible, entry) {
			if (isVisible || this.$el.offsetParent !== null) {
				this.active = true;
				// console.log('war isVisible', isVisible, this.active);
			}
		},
		pushDataLayer: function (data) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(data);
		},
		fetchData: function () {
			// const errorField = diagnosticsApp.querySelector('[data-error-field]');
			let url = this.dataofferurl;
			let urlParams = window.location.search;
			// let disabledFilters = {};

			if (urlParams) {
				this.query = [];
				urlParams = urlParams.replace("?", "&")
				url = url + urlParams;
			}
			if (this.query.length > 0) {
				if (url.indexOf("&") > -1) {
					url = url.slice(0, url.indexOf("&"));
				}
				url = url + "&";
			}
			for (let i = 0; i < this.query.length; i++) {
				if (this.query[i]) {
					url = url + this.query[i];
					if (i < this.query.length - 1) {
						url = url + "&";
					}
				}
			}
			// console.log('vueApplication', this.$root);

			this.$root.showLoader = true;
			let method = "post";
			if (
				window.location.href.indexOf("localhost") > -1 ||
				window.location.href.indexOf("10.0.10.159") > -1
			) {
				method = "get";
			}
			requestHelper
				// .request(diagnosticsApp.getAttribute('method'), diagnosticsApp.getAttribute('data-from'))
				.request(method, url)
				.then((res) => {
					res = JSON.parse(res);
					this.offer_cards = res.offer_cards;
					this.filters = res.filters;
					this.bonus = res.bonus;
					this.packages = res.packages;
					this.popups = res.popups;
					this.noOffer = res.no_offer;
					this.redirect = res.redirect;

					if (res.redirect) {
						// this.setCookies(that);
						// // this.setSduSessionStorage(that);
						// // ga event for success
						// that.gaEvent("skantarek", "success");
						// console.log("sucess redirect ", this.redirect)
						window.location.href = res.redirect;
					} else {
						// console.log("no redirect")
					}

					//zmiana adresu URL strony
					let urlAddress = window.location.href;

					if (res.filters && !this.filtersObj && !urlParams) {
						this.query = [];
						if (this.filters.parameters.elements) {
							const elements = this.filters.parameters.elements;
							elements.forEach(elem => {
								const options = elem.options;
								for (
									let i = 0;
									i < options.length;
									i++
								) {
									let option = options[i];
									if (option.active == true) {
										let queryFilter = `${option.query_parameter}=${option.query_value}`;
										this.query.push(queryFilter);

										if (urlAddress.indexOf("?") > -1) {
											urlAddress = urlAddress.slice(0, urlAddress.indexOf("?"));
											// console.log(urlAddress.indexOf("?"));
										}
										if (queryFilter) {
											urlAddress = urlAddress + "?" + queryFilter;
											window.history.pushState('', '', urlAddress);
										}
									}
								}
							})
						}

					}
					if (res.data_layer) {
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push(res.data_layer);
					}

					this.dataElement = this.$el;
					// console.log(this.results);
					this.$root.showLoader = false;
					// console.log("api url from fetch api", url);
				})
				.catch((e) => {
					console.log(e);
					this.isError = true;
					this.$root.showLoader = false;
					errors.showError(e.status, errorField);
				});
		},
		showDocuments() {
			this.filesVisibility = !this.filesVisibility;
		},
		receiveEmit(filtersId) {
			this.filtersObj = filtersId.filtersObj;
			// console.log(this.filtersObj);
			//zmiana adresu URL
			let urlAddress = window.location.href;
			const paramsObj = this.filtersObj;
			const searchParams = new URLSearchParams(paramsObj);
			// console.log(searchParams.toString());
			if (urlAddress.indexOf("?") > -1) {
				urlAddress = urlAddress.slice(0, urlAddress.indexOf("?"));
			}
			if (searchParams.toString().length > 0) {
				urlAddress = urlAddress + "?" + searchParams.toString();
				window.history.pushState('', '', urlAddress);
			}
			// console.log("url before refresh", urlAddress);
			this.urlRefresh();
			// console.log("url after refresh", urlAddress);

			this.fetchData();
			// console.log("received:", this.filtersObj, urlAddress);
		},
		paramsCleaning(paramVal, paramsObj, key, i) {
			if (paramVal.includes("__")) {
				paramVal = paramVal.replace("__", "_");
				paramsObj[`${key[i]}`] = paramVal;
			}
			if (paramVal.indexOf("_") == 0) {
				paramVal = paramVal.replace("_", "");
				paramsObj[`${key[i]}`] = paramVal;
			}
			if (paramVal.indexOf("_") == paramVal.length - 1) {
				paramVal = paramVal.replace("_", "");
				paramsObj[`${key[i]}`] = paramVal;
			}
			if (paramVal == '_' || paramVal == '__' || paramVal == '') {
				delete paramsObj[`${key[i]}`];
			}
		},
		optionsLoop(disFilt) {
			if (this.filters) {
				const disFilters = this.filters.parameters.elements;
				disFilters.forEach(filter => {
					const options = filter.options;
					for (let i = 0; i < options.length; i++ ) {
					if (options[i].disabled) {
						if (!disFilt[`${options[i].query_parameter}`]) {
							disFilt[`${options[i].query_parameter}`] = `${options[i].query_value}`;
						} else {
							disFilt[`${options[i].query_parameter}`] += `_${options[i].query_value}`;
							const filterArray = disFilt[`${options[i].query_parameter}`].split("_");
							disFilt[`${options[i].query_parameter}`] = filterArray;
						}
					}
				}
				});
			}
		},
		disabledFiltersLoop(disabledFilters, paramsObj) {
			const disFiltersKeys = Object.keys(disabledFilters);
			for (let i = 0; i < disFiltersKeys.length; i++) {
				const disFiltVal = disabledFilters[`${disFiltersKeys[i]}`];
				let apiParamVal = paramsObj[`${disFiltersKeys[i]}`];
				if ((typeof disFiltVal == "string" || disFiltVal instanceof String) && apiParamVal) {
					if (apiParamVal.includes(disFiltVal)) {
						apiParamVal = apiParamVal.replace(disFiltVal, '');
						paramsObj[`${disFiltersKeys[i]}`] = apiParamVal;
						this.paramsCleaning(apiParamVal, paramsObj, disFiltersKeys, i);
					}
				} else if (apiParamVal) {
					for (let j=0; j < disFiltVal.length; j++) {
						apiParamVal.includes(disFiltVal[j]) ? apiParamVal = apiParamVal.replace(disFiltVal[j], "") : apiParamVal = apiParamVal;
						paramsObj[`${disFiltersKeys[i]}`] = apiParamVal;
						this.paramsCleaning(apiParamVal, paramsObj, disFiltersKeys, i);
					}

				}
			}
		},
		objectOfParamsLoop(urlParams, object) {
			const params = urlParams.split("&");
			for (let i = 0; i < params.length; i++) {
				const param = params[i].split("=");
				if (param[0]) {
					object[`${param[0]}`] = `${param[1]}`;
				}
			}
		},
		urlRefresh() {
			let disabledFilters = {};
			let urlParams = {};
			let searchParams = window.location.search;
			let urlAddress = window.location.href;
			this.optionsLoop(disabledFilters);

			if (searchParams) {
				searchParams = searchParams.replace('?','');
				this.objectOfParamsLoop(searchParams, urlParams);
			}

			this.disabledFiltersLoop(disabledFilters, urlParams);
			const urlParamsKeys = Object.keys(urlParams);
			let newUrlParams = '';
			for (let i = 0; i < urlParamsKeys.length; i++) {
				newUrlParams = newUrlParams + `&${urlParamsKeys[i]}=${urlParams[urlParamsKeys[i]]}`;
			}
			if (newUrlParams.indexOf("&") == 0) {
				newUrlParams = newUrlParams.slice(1, newUrlParams.length);
			}
			if (urlAddress.indexOf("?") > -1) {
				urlAddress = urlAddress.slice(0, urlAddress.indexOf("?"));
			}
			if (newUrlParams) {
				urlAddress = urlAddress + "?" + newUrlParams;
				window.history.pushState('', '', urlAddress);
			}
		}
	},
});